// extracted by mini-css-extract-plugin
export default {"spinner":"Spinner_spinner__4mB2g","loader-spinner":"Spinner_loader-spinner__Vk3TO"};